// import "./About.module.scss";
import { Helmet } from 'react-helmet-async'
import styles from './About.module.scss'

const About = () => {
  return (
    <div className={styles.about}>
      <Helmet>
        <title>About Chauffeur Rides Ltd | Luxury Chauffeur Service London</title>
        <meta name="description" content="Discover our commitment to excellence, reliability and luxury. Chauffeur Rides Ltd delivers premium airport, corporate and private chauffeur services in London." />
      </Helmet>
      <div className="container">
        <h1>About us</h1>

        <div className={styles.about__block}>
          <h2>Our Story</h2>
          <p>
            At Chauffeur Rides Ltd, established in 2022 we believe every journey should be as
            enjoyable as the destination. Our professional chauffeur service is designed to provide
            comfort, safety, and a touch of luxury for every passenger.
          </p>
          <p>
            Whether you're heading to the airport, attending a business meeting, or celebrating a
            special occasion, our team ensures a smooth and stress-free experience. With a fleet of
            well-maintained premium vehicles and highly trained chauffeurs, we go beyond
            transportation — we deliver peace of mind.
          </p>
        </div>

        <div className={styles.about__block}>
          <h2>Why Choose Us?</h2>
          <ul>
            <li>
              <strong>Professional Chauffeurs</strong> – Courteous, punctual, and discreet.
            </li>
            <li>
              <strong>Luxury Vehicles</strong> – Clean, comfortable, and equipped with modern
              amenities.
            </li>
            <li>
              <strong>Personalized Service</strong> – Tailored to meet your unique needs and
              schedule.
            </li>
            <li>
              <strong>Safety First</strong> – Every ride prioritizes your security and comfort.
            </li>
          </ul>
        </div>

        <div className={styles.about__block}>
          <p>
            At the heart of our service is a commitment to excellence. We don't just drive you — we
            take care of you, every step of the way.
          </p>
        </div>
      </div>
    </div>
  )
}
export default About
